// extracted by mini-css-extract-plugin
export default {"ActivityReport":"styles_ActivityReport__rQqWV","ActivityPagination":"styles_ActivityPagination__GGPJp"};